import * as yup from "yup";
import {
  ClaimReportBuildingReceipt,
  ClaimReportEnterpriseReceipt,
  ClaimReportGlassesReceipt,
  ClaimReportLiabilityDamageReceipt,
  ClaimReportMachineReceipt,
  ClaimReportMotorVehicleReceipt,
  ClaimReportTheftReceipt,
} from "./CustomerReceipts";

yup.setLocale({
  mixed: {
    required: "Dette felt er obligatorisk",
  },
});

let templateToUse: string;

export const validationSchema = (formData: any) => {
  switch (formData.claimType) {
    case "Ansvarsskade":
      templateToUse = ClaimReportLiabilityDamageReceipt(formData);
      return yup.object().shape({
        policyNumber: yup.string().required(),
        companyName: yup.string().required(),
        cvrNumber: yup.string(),
        contactPersonName: yup.string().required(),
        contactPersonPhoneNumber: yup.string().required(),
        email: yup
          .string()
          .required()
          .email(`${formData.email} er ikke en gyldig email`),
        referenceNumber: yup.string(),
        isAnyoneInjured: yup.string().required(),
        damageLocation: yup.string().required(),
        damageDescription: yup.string().required(),
        damageReportedOwnInsuranceCompany: yup.string().required(),
        claimFromInjuredParty: yup.string().required(),
        claimAmount: yup.string(),
        claimDate: yup.string(),
        injuredPartyName: yup.string().required(),
        injuredPartyPhoneNumber: yup.string().required(),
        injuredPartyEmail: yup
          .string()
          .email(`${formData.email} er ikke en gyldig email`),
        injuredPartyAddress: yup.string(),
        injuredPartyPostalCode: yup.string(),
        injuredPartyCVRNumber: yup.string(),
      });
    case "Brilleskade":
      templateToUse = ClaimReportGlassesReceipt(formData);
      return yup.object().shape({
        cvrNumber: yup.string().required(),
        policyNumber: yup.string().required(),
        contactPersonName: yup.string().required(),
        email: yup
          .string()
          .required()
          .email(`${formData.email} er ikke en gyldig email`),
        contactPersonPhoneNumber: yup.string().required(),
        injuredPartyName: yup.string().required(),
        injuredPartyDOB: yup.string().required(),
        injuredPartyEmployment: yup.string().required(),
        injuredPartyAddress: yup.string().required(),
        isInjuredPartyEmployedAtReporter: yup.string().required(),
        injuryDate: yup.string().required(),
        injuryLocation: yup.string().required(),
        kindOfWorkWhenInjured: yup.string().required(),
        injuryReason: yup.string().required(),
        hadGlassesOn: yup.string().required(),
        glassesLocation:
          formData.hadGlassesOn === "Nej"
            ? yup.string().required()
            : yup.string(),
        dateOfPurchase: yup.string().required(),
        originalPriceOfGlasses: yup.string().required(),
        priceEstimate: yup.string().required(),
        consent: yup.bool().oneOf([true], "Du skal give samtykke"),
      });
    case "Bygningsskade":
      templateToUse = ClaimReportBuildingReceipt(formData);
      return yup.object().shape({
        cvrNumber: yup.string().required(),
        policyNumber: yup.string().required(),
        contactPersonName: yup.string().required(),
        email: yup
          .string()
          .required()
          .email(`${formData.email} er ikke en gyldig email`),
        contactPersonPhoneNumber: yup.string().required(),
        propertyInspectorPhoneNumber: yup.string().required(),
        damagedPropertyAddress: yup.string().required(),
        isPropertyVATRegistered: yup.string().required(),
        propertyType: yup.string().required(),
        propertyUse: yup.string().required(),
        insuredByOther: yup.string().required(),
        insuranceCompanyDetails:
          formData.insuredByOther === "Ja"
            ? yup.string().required()
            : yup.string(),
        damageDetails: yup.string().required(),
        insuranceItemsDamageDetails: yup.string().required(),
        damageDate: yup.string().required(),
        damageDiscovered: yup.string().required(),
        othersToBlame: yup.string().required(),
        whoToBlame:
          formData.otherstoBlame === "Ja"
            ? yup.string().required()
            : yup.string(),
        typeOfDamage: yup.string().required(),
        priceRepairEstimate: yup.string().required(),
        consent: yup.bool().oneOf([true], "Du skal give samtykke"),
      });
    case "Entrepriseskade":
      templateToUse = ClaimReportEnterpriseReceipt(formData);
      return yup.object().shape({
        cvrNumber: yup.string().required(),
        policyNumber: yup.string().required(),
        contactPersonName: yup.string().required(),
        email: yup
          .string()
          .required()
          .email(`${formData.email} er ikke en gyldig email`),
        contactPersonPhoneNumber: yup.string().required(),
        defendantsAddress: yup.string().required(),
        defendantsEmploymentAndName: yup.string().required(),
        defendantsCVRNumber: yup.string().required(),
        victimsEmploymentAndName: yup.string().required(),
        victimsAddress: yup.string().required(),
        victimsPhoneNumber: yup.string().required(),
        isVictimInEmploymentWithDefendant: yup.string().required(),
        typeofRelationship:
          formData.isVictimInEmploymentWithDefendant === "Ja"
            ? yup.string().required()
            : yup.string(),
        damageDate: yup.string().required(),
        damageLocation: yup.string().required(),
        damageOccuredCircumstances: yup.string().required(),
        extentOfDamage: yup.string().required(),
        claimsMade: yup.string().required(),
        priceEstimateDamage: yup.string().required(),
        wasPropertyForLoanTransportationProcessing: yup.string().required(),
        propertyUsedForDetails:
          formData.wasPropertyForLoanTransportationProcessing === "Ja"
            ? yup.string().required()
            : yup.string(),
        whoToBlameAndWhy: yup.string().required(),
        policeReportMade: yup.string().required(),
        policeStation:
          formData.policeReportMade === "Ja"
            ? yup.string().required()
            : yup.string(),
        arbejdstilsynetInvolved: yup.string().required(),
        witnesses: yup.string().required(),
        reportedToOwnInsuranceCompany: yup.string().required(),
        insuranceCompanyName:
          formData.reportedToOwnInsuranceCompany === "Ja"
            ? yup.string().required()
            : yup.string(),
        victimsPolicyNumber:
          formData.reportedToOwnInsuranceCompany === "Ja"
            ? yup.string().required()
            : yup.string(),
        consent: yup.bool().oneOf([true], "Du skal give samtykke"),
      });
    case "Maskinskade":
      templateToUse = ClaimReportMachineReceipt(formData);
      return yup.object().shape({
        cvrNumber: yup.string().required(),
        policyNumber: yup.string().required(),
        contactPersonName: yup.string().required(),
        email: yup
          .string()
          .required()
          .email(`${formData.email} er ikke en gyldig email`),
        contactPersonPhoneNumber: yup.string().required(),
        damageAddress: yup.string().required(),
        machineBelongsToCompany: yup.string().required(),
        machineBelongsTo:
          formData.machineBelongsToCompany === "Nej"
            ? yup.string().required()
            : yup.string(),
        damageDate: yup.string().required(),
        product: yup.string().required(),
        productType: yup.string().required(),
        productChassisNumber: yup.string().required(),
        productYearModel: yup.string().required(),
        productPositionNumberOnPolicy: yup.string().required(),
        damageDetailsAndCause: yup.string().required(),
        machineCaretakerDamageOccured: yup.string().required(),
        machineRepairOnSiteOrSpecialWorkshop: yup.string().required(),
        whoRepairsMachine: yup.string().required(),
        machinePreviouslyRepaired: yup.string().required(),
        insuredByOthers: yup.string().required(),
        insuranceCompanyNameAndAmount:
          formData.insuredByOthers === "Ja"
            ? yup.string().required()
            : yup.string(),
        estimateRepairTime: yup.string().required(),
        workshopNameAndAddress: yup.string().required(),
        workshopPriceEstimate: yup.string().required(),
        ownPriceEstimate: yup.string().required(),
        consent: yup.bool().oneOf([true], "Du skal give samtykke"),
      });
    case "Motorkøretøj":
      templateToUse = ClaimReportMotorVehicleReceipt(formData);
      return yup.object().shape({
        companyName: yup.string().required(),
        cvrNumber: yup.string().required(),
        contactPersonName: yup.string().required(),
        email: yup
          .string()
          .required()
          .email(`${formData.email} er ikke en gyldig email`),
        contactPersonPhoneNumber: yup.string().required(),
        isMotorVehicleRegistered: yup.string().required(),
        registrationNumber:
          formData.isMotorVehicleRegistered === "Ja"
            ? yup.string().required()
            : yup.string(),
        chassisNumber:
          formData.isMotorVehicleRegistered === "Ja"
            ? yup.string().required()
            : yup.string(),
        productAndType:
          formData.isMotorVehicleRegistered === "Ja"
            ? yup.string().required()
            : yup.string(),
        yearModel:
          formData.isMotorVehicleRegistered === "Ja"
            ? yup.string().required()
            : yup.string(),
        rescueCorpSubscription: yup.string().required(),
        useAtTimeOfDamage: yup.string().required(),
        vehiclePartOfVATCompany: yup.string().required(),
        damageDetails: yup.string().required(),
        damageDateAndTime: yup.string().required(),
        sceneOfAccidentAddress: yup.string().required(),
        policeReportMade: yup.string().required(),
        policeStation:
          formData.policeReportMade === "Ja"
            ? yup.string().required()
            : yup.string(),
        driverTookAlcoholTest: yup.string().required(),
        driverTookBloodTest: yup.string().required(),
        driversNameAndAddress: yup.string().required(),
        driversPhoneNumber: yup.string().required(),
        driverHadValidDriversLicense: yup.string().required(),
        driversLicenseNumber: yup.string().required(),
        driversLicenseDateOfIssue: yup.string().required(),
        driversLicenseType: yup.string().required(),
        speedOfVehicle: yup.string().required(),
        wereLightsOn: yup.string().required(),
        wereStreetLightsOn: yup.string().required(),
        accidentSiteInformed: yup.string().required(),
        weatherAndDrivingConditions: yup.string().required(),
        isVehicleDamaged: yup.string().required(),
        vehicleDamageDetails:
          formData.isVehicleDamaged === "Ja"
            ? yup.string().required()
            : yup.string(),
        wasThereOtherParty: yup.string().required(),
        otherPartyComeFrom:
          formData.wasThereOtherParty === "Ja"
            ? yup.string().required()
            : yup.string(),
        otherPartyDetails:
          formData.wasThereOtherParty === "Ja"
            ? yup.string().required()
            : yup.string(),
        otherPartyVehicleDamaged:
          formData.wasThereOtherParty === "Ja"
            ? yup.string().required()
            : yup.string(),
        otherPartySpeed:
          formData.wasThereOtherParty === "Ja"
            ? yup.string().required()
            : yup.string(),
        otherPartyLightsOn:
          formData.wasThereOtherParty === "Ja"
            ? yup.string().required()
            : yup.string(),
        otherPartyVehicleDamageDetails:
          formData.otherPartyVehicleDamaged === "Ja"
            ? yup.string().required()
            : yup.string(),
        whoToBlame:
          formData.wasThereOtherParty === "Ja"
            ? yup.string().required()
            : yup.string(),
        witnessToAccident: yup.string().required(),
        witnessLocation:
          formData.witnessToAccident === "Ja"
            ? yup.string().required()
            : yup.string(),
        witnessOtherLocation:
          formData.witnessLocation === "Andet"
            ? yup.string().required()
            : yup.string(),
        personInjured: yup.string().required(),
        personInjuredDetails:
          formData.personInjured === "Ja"
            ? yup.string().required()
            : yup.string(),
        consent: yup.bool().oneOf([true], "Du skal give samtykke"),
      });
    case "Tyveri":
      templateToUse = ClaimReportTheftReceipt(formData);
      return yup.object().shape({
        companyName: yup.string().required(),
        cvrNumber: yup.string().required(),
        policyNumber: yup.string().required(),
        contactPersonNameAndEmployment: yup.string().required(),
        email: yup
          .string()
          .required()
          .email(`${formData.email} er ikke en gyldig email`),
        contactPersonPhoneNumber: yup.string().required(),
        theftLocation: yup.string().required(),
        sceneOfAccidentAddress: yup.string().required(),
        timeOfAccident: yup.string().required(),
        theftDiscovered: yup.string().required(),
        theftDetails: yup.string().required(),
        carSecurelyLocked: yup.string().required(),
        windowsClosed: yup.string().required(),
        alarmActivated: yup.string().required(),
        theftReportedDate: yup.string().required(),
        policeStation: yup.string().required(),
        whoReportedDamage: yup.string().required(),
        stolenItemsBelongToPolicyholder: yup.string().required(),
        insuredByOthers: yup.string().required(),
        stolenItemsBelongToOther:
          formData.stolenItemsBelongToPolicyholder === "Nej"
            ? yup.string().required()
            : yup.string(),
        insuranceCompanyName:
          formData.insuredByOthers === "Ja"
            ? yup.string().required()
            : yup.string(),
        totalClaim: yup.string().required(),
        consent: yup.bool().oneOf([true], "Du skal give samtykke"),
      });
  }
};

export const to = (body: any) => {
  if (body.claimType === "Ansvarsskade") {
    return "ansvar@gjensidige.dk";
  } else {
    return "dibyggeri@gjensidige.dk";
  }
};

export const receipt = (_body: any) => {
  return {
    subject: "Tak for din anmeldelse",
    message: templateToUse,
  };
};
